var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 616 497.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-face-base-1 {\n        fill: #c3825a;\n      }\n\n      .cls-face-base-2 {\n        fill: #f88459;\n      }\n\n      .cls-face-base-3 {\n        fill: #d79db6;\n      }\n\n      .cls-face-base-4 {\n        fill: #fabdc6;\n      }\n\n      .cls-face-base-5 {\n        fill: #fff;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-face-base-7 {\n        fill: #42210b;\n      }\n\n      .cls-face-base-8 {\n        fill: #f44d41;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 551.16,
    cy: 346.91,
    r: 64.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-skin-color",
    cx: 64.84,
    cy: 346.91,
    r: 64.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-1",
    d: "M64.84,282.06c-9.22,0-17.99,1.94-25.94,5.41v24.99c0,36.53,10.65,70.54,28.95,99.2,34.41-1.57,61.83-29.96,61.83-64.77s-29.03-64.84-64.84-64.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-1",
    d: "M551.16,282.06c9.22,0,17.99,1.94,25.94,5.41v24.99c0,36.53-10.65,70.54-28.95,99.2-34.41-1.57-61.83-29.96-61.83-64.77,0-35.81,29.03-64.84,64.84-64.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M308,0h0C449.36,0,564.13,114.77,564.13,256.13v56.34c0,101.91-82.74,184.65-184.65,184.65h-142.94c-101.91,0-184.65-82.74-184.65-184.65v-56.34C51.87,114.77,166.64,0,308,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-face-base-5",
    cx: 181.56,
    cy: 248.56,
    r: 61.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-7",
    d: "M181.56,313.35c-35.72,0-64.79-29.06-64.79-64.79s29.06-64.79,64.79-64.79,64.79,29.06,64.79,64.79-29.06,64.79-64.79,64.79ZM181.56,190.15c-32.21,0-58.41,26.2-58.41,58.41s26.2,58.41,58.41,58.41,58.41-26.2,58.41-58.41-26.2-58.41-58.41-58.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-face-base-7",
    cx: 202.09,
    cy: 247.48,
    r: 38.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-7",
    d: "M202.09,289.63c-23.24,0-42.15-18.91-42.15-42.15s18.91-42.15,42.15-42.15,42.15,18.91,42.15,42.15-18.91,42.15-42.15,42.15ZM202.09,211.82c-19.66,0-35.66,16-35.66,35.66s16,35.66,35.66,35.66,35.66-16,35.66-35.66-16-35.66-35.66-35.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-3",
    d: "M181.56,183.72c-35.75,0-64.84,29.09-64.84,64.84,0,5.14.62,10.13,1.75,14.92l120.5-45.02c-10.86-20.64-32.51-34.75-57.41-34.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-face-base-5",
    cx: 422.55,
    cy: 248.56,
    r: 61.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-7",
    d: "M422.55,313.35c-35.72,0-64.79-29.06-64.79-64.79s29.06-64.79,64.79-64.79,64.79,29.06,64.79,64.79-29.06,64.79-64.79,64.79ZM422.55,190.15c-32.21,0-58.41,26.2-58.41,58.41s26.2,58.41,58.41,58.41,58.41-26.2,58.41-58.41-26.2-58.41-58.41-58.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-face-base-7",
    cx: 442.01,
    cy: 247.48,
    r: 38.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-7",
    d: "M442.01,289.63c-23.24,0-42.15-18.91-42.15-42.15s18.91-42.15,42.15-42.15,42.15,18.91,42.15,42.15-18.91,42.15-42.15,42.15ZM442.01,211.82c-19.66,0-35.66,16-35.66,35.66s16,35.66,35.66,35.66,35.66-16,35.66-35.66-16-35.66-35.66-35.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-3",
    d: "M422.55,183.72c35.75,0,64.84,29.09,64.84,64.84,0,5.14-.62,10.13-1.75,14.92l-120.5-45.02c10.86-20.64,32.51-34.75,57.41-34.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-face-base-2",
    points: "304.95 255.05 275.42 347.62 334.48 347.62 304.95 255.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-face-base-8",
    points: "305.43 256.55 305.43 347.62 334.48 347.62 305.43 256.55"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-face-base-7",
    d: "M382.4,397.48c-2.14-2.27-5.68-2.62-8.13-.68-6.84,5.42-13.78,8.45-20.69,9.04-6.82.56-17.13-.75-30.64-3.93l-.98-.23c-3.11-.74-6.97-1.66-12.29-1.95-.36-.02-.72,0-1.08-.01-.8-.03-1.59-.03-2.38-.03-.79,0-1.59,0-2.38.03-.36.01-.72,0-1.08.01-5.32.29-9.19,1.21-12.29,1.95l-.98.23c-13.52,3.17-23.83,4.49-30.64,3.93-6.91-.58-13.85-3.61-20.69-9.04-2.44-1.94-5.99-1.59-8.13.68-2.46,2.62-2.12,6.78.71,9.01,8.71,6.86,17.79,10.72,27.09,11.5,1.38.12,2.81.17,4.28.17,11.56,0,25.29-3.23,30.18-4.38l.38-.09v.03c1.27-.35,2.54-.64,3.81-.89.16-.03.31-.06.47-.1,2.48-.47,4.97-.75,7.45-.85.61-.02,1.22-.03,1.83-.02.61,0,1.22,0,1.83.02,2.48.1,4.97.37,7.45.85.16.03.32.06.47.1,1.27.25,2.54.54,3.8.89v-.03s.39.09.39.09c4.88,1.15,18.62,4.38,30.18,4.38,1.47,0,2.9-.05,4.28-.17,9.29-.78,18.38-4.64,27.09-11.5,2.83-2.23,3.17-6.39.71-9.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-face-base-7",
    cx: 224.79,
    cy: 347.99,
    r: 6.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-base-4",
    cx: 444.09,
    cy: 355.48,
    rx: 37.9,
    ry: 19.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-face-base-4",
    cx: 150.14,
    cy: 355.48,
    rx: 37.9,
    ry: 19.16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace1);
export default __webpack_public_path__ + "static/media/face1.81d78aad218984cdb4f8be0e33268591.svg";
export { ForwardRef as ReactComponent };